import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from './components/inputs/inputs.module';
import { SharedModule } from './components/shared/shared.module';
import { ErrorInterceptor } from './interceptors/interceptor';  // Importamos el interceptor
import { InterceptorErrorComponent } from './pages/interceptor-error/interceptor-error.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutComponent } from './components/admin/layout/layout.component';
import { ClientStructureComponent } from './components/providersClient/client-structure/client-structure.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { TreatmentPolicyComponent } from './pages/treatment-policy/treatment-policy.component';

@NgModule({
  declarations: [
    AppComponent,
    InterceptorErrorComponent,
    LayoutComponent,
    ClientStructureComponent,
    TermsAndConditionsComponent,
    TreatmentPolicyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    InputsModule,
    SharedModule,
    NoopAnimationsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
